import { array, literal, struct, union } from 'io-ts/Decoder';

import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const SortableColumn = iotsUtils.fromList(
	constants.report.estimateOutcomeTrx.SortableColumns
);

export const SortableColumns = array(
	struct({
		field: SortableColumn,
		direction: union(literal('asc'), literal('desc')),
	})
);
